import { useTranslate } from '@tolgee/react';
import { useRouter } from 'next/router';
import { useCallback, useMemo, useState } from 'react';

import EmojiThanks from '../assets/icons/EmojiThanks';
import { Button } from '../components/_atoms/Button';
import { IconWrapper } from '../components/_atoms/IconWrapper';
import BaseModal from '../components/_molecules/BaseModal';
import { useMetrics } from './useMetrics';
import { CenteredContainer } from '../styles/CenteredContainer';
import useSignIn from './useSignIn';

function useAuthGuardPrompt(
  templateId?: string,
  creatorId?: string,
  generatorId?: string,
) {
  const [showAuthGuard, setShowAuthGuard] = useState(false);
  const { t } = useTranslate();
  const router = useRouter();
  const metrics = useMetrics(true);
  const promptAuthGuard = useCallback(() => {
    metrics.logEvent('AuthGuard.Discover.Prompted', {
      templateId,
      creatorId,
      generatorId,
    });
    setShowAuthGuard(true);
  }, [creatorId, templateId, metrics, generatorId]);
  const hideAuthGuard = useCallback(() => {
    metrics.logEvent('AuthGuard.Discover.Dismissed', {
      templateId,
      creatorId,
      generatorId,
    });
    setShowAuthGuard(false);
  }, [creatorId, templateId, metrics, generatorId]);
  const { signIn } = useSignIn();

  const authGuardComponent = useMemo(
    () => (
      <BaseModal
        title={t('You need to be logged in')}
        open={showAuthGuard}
        onCancel={hideAuthGuard}
      >
        <CenteredContainer style={{ flexDirection: 'column' }}>
          <IconWrapper height="150px" width="150px">
            <EmojiThanks />
          </IconWrapper>
          <p
            style={{
              marginTop: 20,
              fontWeight: 'bold',
              width: '100%',
              textAlign: 'center',
            }}
          >
            {t(
              'InOrderTo',
              'In order to get the most out of Curipod. Please log into your account or create a new one.',
            )}
          </p>
        </CenteredContainer>
        <CenteredContainer>
          <Button
            width="160px"
            height="42px"
            type="ghost"
            onClick={() => {
              metrics.logEvent('AuthGuard.Discover.SignIn', {
                templateId,
                creatorId,
                generatorId,
              });
              signIn();
            }}
          >
            {t('Login')}
          </Button>

          <Button
            height="42px"
            minWidth="160px"
            styles={{ paddingTop: '11.5px !important', marginLeft: 20 }}
            type="primary"
            onClick={() => {
              metrics.logEvent('AuthGuard.Discover.SignUp', {
                templateId,
                creatorId,
                generatorId,
              });
              router.push({
                pathname: '/signup',
                query: { callback: window.location.href },
              });
            }}
          >
            {t('SignupItFree', "Sign up - It's free")}
          </Button>
        </CenteredContainer>
      </BaseModal>
    ),
    [t, showAuthGuard, hideAuthGuard, templateId, creatorId, signIn, router, generatorId],
  );

  return {
    showAuthGuard: promptAuthGuard,
    hideAuthGuard,
    authGuardComponent,
  };
}

export default useAuthGuardPrompt;
